export class TransportadorasModel {
  id: number;
  nome: string;
}



// WEBPACK FOOTER //
// ./src/app/transportadoras/transportadoras.model.ts